import axios from 'axios';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../../styles/GlobalComponents';

import Spinner from '../../../components/common/Spinner';

import { P2, P3 } from '../../../styles/FontStyles';

import ReactCodeInput from 'react-code-input';
import { color } from '../../../styles/GlobalStyles';
import { createWithdrawPartner } from './Withdraw.actions';

import { useAppSelector } from '../../../app/hooks';
import {
  ErrorToast,
  SuccessToast
} from '../../../components/common/Toasts/Toasts';

interface TwoFASetupProps {
  setStep: Dispatch<SetStateAction<number>>;
  amount: string;
  fee: any;
  userWallets: any;
  selected: any;
  networkType: any;
  setAmount: any;
  selectedToken: any;
}

export const TwoFASetup = ({
  setStep,
  amount,
  fee,
  userWallets,
  selected,
  networkType,
  setAmount,
  selectedToken
}: TwoFASetupProps) => {
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const dispatch = useDispatch();

  const { loading } = useAppSelector((state) => state.wallets);
  const { verificationStatus } = useAppSelector((state) => state.settings);
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/user/balance/withdraw/email/code`, {
        amount: parseInt(amount) - parseInt(fee),
        userWalletId: userWallets[selected].id,
        networkType,
        networkCurrencyType: selectedToken.token.toLowerCase()
      });

      SuccessToast('Code sent successfully');
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    dispatch(
      createWithdrawPartner({
        amount: parseInt(amount),
        userWalletId: userWallets[selected].id,
        setStep,
        emailCode: code,
        twoFACode: code2Fa,
        networkType,
        setAmount,
        networkCurrencyType: selectedToken.token.toLowerCase(),
        setLoadingCode
      })
    );
  };

  return (
    <div style={{ marginTop: '20vh' }}>
      {loading || loadingCode ? (
        <Spinner />
      ) : (
        <form onSubmit={onHandleSubmit}>
          <Flexed between>
            <P2 bold color={color.colors.neutral700}>
              Email verification code
            </P2>
            <P2
              bold
              style={{ cursor: 'pointer' }}
              color={color.colors.primary900}
              onClick={() => sendCode()}>
              Send Code
            </P2>
          </Flexed>
          <SecurityCodeWrapper>
            <ReactCodeInput
              fields={7}
              value={code}
              onChange={setCode}
              type={'number'}
              name='phone code'
              inputMode='numeric'
            />
          </SecurityCodeWrapper>
          <P3 color={color.colors.neutral500} mb='40'>
            {isCodeSent && `Enter the 7 digit code sent to ${user?.email}`}
          </P3>

          {verificationStatus && (
            <div>
              <Flexed between>
                <P2 bold color={color.colors.neutral700}>
                  2FA verification code
                </P2>
              </Flexed>
              <SecurityCodeWrapper is2Fa>
                <ReactCodeInput
                  fields={6}
                  value={code2Fa}
                  onChange={setCode2Fa}
                  type={'number'}
                  name='phone code2 '
                  inputMode='numeric'
                />
              </SecurityCodeWrapper>
              <P3 color={color.colors.neutral500} mb='10'>
                Enter the 6 digit code from your 2FA authenticator
              </P3>
            </div>
          )}
          <Button m='30px 0 10px 0' disabled={code === '' ? true : false}>
            Confirm
          </Button>
        </form>
      )}
    </div>
  );
};
